import { useState, useCallback } from 'react';
import { useMediaQuery } from '@mui/material';

interface IAttachFile {
  onDeleteClick?: () => void;
  onDownloadFile?: () => void;
  onViewFile?: () => void;
  isSent?: boolean;
  hasView?: boolean;
  canDelete?: boolean;
}

const useFileActions = ({ onDownloadFile, onViewFile, onDeleteClick, hasView, canDelete }: IAttachFile) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [openActionsDrawer, setOpenActionsDrawer] = useState(false);

  const handleDrawerToggle = useCallback(() => {
    setOpenActionsDrawer((prev) => !prev);
  }, []);

  const fileActions = [
    { label: 'View', action: () => onViewFile?.(), enable: !!hasView },
    { label: 'Download', action: () => onDownloadFile?.() },
    { label: 'Delete', action: () => canDelete && onDeleteClick?.(), enable: canDelete },
  ];

  return { openActionsDrawer, handleDrawerToggle, fileActions, isMobile };
};

export default useFileActions;
